module.exports = __webpack_public_path__ + "ba125d3cbb05694cff1861dcba6b9b18.gif";